import LoginForm from './LoginForm'
import { connect, actions, selectors } from '../../../stores'

const mapStateToProps = state => ({
  additionalFields: selectors.auth.selectAdditionalVerificationFields(state),
  isLoading: selectors.auth.selectIsLoading(state),
  challengeName: selectors.auth.selectChallengeName(state),
  errorMessage: selectors.auth.selectErrorMessage(state),
  emailError: selectors.auth.selectEmailError(state),
})

const mapDispatchToProps = dispatch => ({
  signIn: payload => dispatch(actions.auth.signIn(payload)),
  signInFacebook: payload => dispatch(actions.auth.signInFacebook(payload)),
  signInGoogle: payload => dispatch(actions.auth.signInGoogle(payload)),
  confirmSignIn: payload => dispatch(actions.auth.confirmSignIn(payload)),
  completeNewPassword: payload => dispatch(actions.auth.completeNewPassword(payload)),
  setupOneTimePassword: payload => dispatch(actions.auth.setupOneTimePassword(payload)),
  resetState: payload => dispatch(actions.auth.resetState(payload))
})

const ConnectedLoginForm = connect(
  mapStateToProps,
  mapDispatchToProps
)(LoginForm)

export default ConnectedLoginForm
